import { render, staticRenderFns } from "./ActionNegativeDateShiftFeedback.vue?vue&type=template&id=8a4d6f74&scoped=true&"
import script from "./ActionNegativeDateShiftFeedback.vue?vue&type=script&lang=js&"
export * from "./ActionNegativeDateShiftFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ActionNegativeDateShiftFeedback.vue?vue&type=style&index=0&id=8a4d6f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4d6f74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
